import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import { Table, TableColumn } from "../../../components/table";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import axios from "axios";
import { Row, Pagination, Modal, Col } from "antd";
import { Icon } from "@iconify/react";
import "../../../assets/styles/admin/branchList.scss";

const Branches = () => {
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [countPage, setCountPage] = useState(1);
  const [dataBranches, setDataBranches] = useState([]);
  const { confirm } = Modal;

  const column = [
    {
      title: "",
    },
    {
      title: "Code",
      align: "center",
    },
    {
      title: "Branch",
      align: "",
    },
    {
      title: "Tel.",
      align: "center",
    },
    {
      title: "Branch Address",
      align: "",
    },
    {
      title: "Action",
      align: "center",
      colspan: 3,
    },
  ];

  const getData = () => {
    axios.get(`/branches?page=${page}`).then((res) => {
      console.log("ressss", res.data.data);
      setDataBranches(res.data.data);
      setCountPage(res.data.pages);
      setPage(res.data.page);
    });
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบสาขา ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} branch from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        // console.log("OK");
        deleteData(id);
      },
      onCancel() {
        // console.log("Cancel");
      },
    });
  }

  const deleteData = (id: any) => {
    axios.delete(`/branches/${id}`).then((res) => {
      setTimeout(() => getData(), 200);
    });
  };

  useEffect(() => {
    getData();
  }, []);
  const onchangePage = (page: any) => {
    setPage(page);
    getData();
  };

  return (
    <div>
      <HeaderBar title="BRANCHES LIST" />
      <div style={{ padding: "0px 40px" }}>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <MainButton
            title="CREATE BRANCHES"
            onClick={() => history.push(`branches/create`)}
          >
            <Icon
              icon="ant-design:plus-outlined"
              width="24"
              height="24"
              vFlip={true}
              color="#FFF"
            />
          </MainButton>
          {/* <div className="btn-new">สร้าง OPD ใหม่</div> */}
        </div>
        <div className="mt-20">
          <Table header={column}>
            {dataBranches.map((item: any, index: any) => (
              <tr
                key={index}
                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                style={{ cursor: "pointer" }}
              >
                {console.log("item", item)}
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  {item.code}
                </TableColumn>
                <TableColumn width="10%">{item.name}</TableColumn>
                <TableColumn width="8%">{item.phone}</TableColumn>
                <TableColumn width="20%">{item.address}</TableColumn>
                <TableColumn width="3%" align="center">
                  <div
                    onClick={() => history.push(`branches/${item._id}/edit`)}
                  >
                    <Icon
                      icon="clarity:eye-line"
                      width="20"
                      height="20"
                      color="#5BAEA9"
                    />
                  </div>
                </TableColumn>
                <TableColumn width="3%" align="center">
                  <div
                    onClick={() =>
                      history.push(`branches/${item._id}/viewroom`)
                    }
                  >
                    <Icon
                      icon="fluent:conference-room-28-regular"
                      width="20"
                      height="20"
                      color="#5BAEA9"
                    />
                  </div>
                </TableColumn>

                <TableColumn width="3%" align="center">
                  <div
                    onClick={() => {
                      // deleteData(item._id);
                      showDeleteConfirm(item._id, item.name);
                    }}
                  >
                    <Icon
                      icon="fa-solid:trash-alt"
                      width="20"
                      height="20"
                      color="#FF6760"
                    />
                  </div>
                </TableColumn>
              </tr>
            ))}
          </Table>
          <Row justify="end" className="pagination-branchList">
            <Pagination
              defaultCurrent={page}
              total={countPage}
              onChange={(e: any) => {
                onchangePage(e);
              }}
            />
          </Row>
        </div>
      </div>
    </div>
  );
};
export default Branches;
